const ITEMS = ["Technology", "Manufacturing", "Clean Energy", "Agriculture", "Real Estate", "Engineering Tomorrow"];

const MarqueeRow = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="text-outline whitespace-nowrap px-8 font-display text-7xl font-bold uppercase tracking-tighter md:text-9xl">
          {item}
        </span>
        <span className="font-mono text-2xl text-cyber/40 md:text-4xl">//</span>
      </span>
    ))}
  </div>
);

const Marquee = () => {
  return (
    <div
      className="relative overflow-hidden border-y border-white/10 bg-abyss py-16 md:py-24"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max">
        <MarqueeRow />
        <MarqueeRow />
      </div>
    </div>
  );
};

export default Marquee;
